<script>
export default {
	name: 'HistoryBadge',
	props: {
		// green | blue | orange | red | grey
		variant: {
			type: String,
			default: 'grey',
		},
		// '' | check | arrow-out | arrow-in
		icon: {
			type: String,
			default: '',
		},
	},
}
</script>

<template>
	<span class="history-badge" :class="`history-badge--${variant}`">
		<svg
			v-if="icon === 'check'"
			class="history-badge__icon"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 13l4 4 10-10"
				stroke="currentColor"
				stroke-width="2.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
		<svg
			v-else-if="icon === 'arrow-out' || icon === 'arrow-in'"
			class="history-badge__icon"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				:d="icon === 'arrow-in' ? 'M17 7L7 17m0 0h8m-8 0V9' : 'M7 17L17 7m0 0H9m8 0v8'"
				stroke="currentColor"
				stroke-width="2.2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
		<slot />
	</span>
</template>

<style scoped>
.history-badge {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	padding: 4px 12px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 600;
	line-height: 1.2;
	white-space: nowrap;
}

.history-badge__icon {
	width: 13px;
	height: 13px;
	display: block;
}

.history-badge--green {
	background: #d5f5e3;
	color: #1e8e4f;
}
.history-badge--blue {
	background: #157fee;
	color: #ffffff;
}
.history-badge--orange {
	background: #fdeccd;
	color: #c77700;
}
.history-badge--red {
	background: #fcdada;
	color: #cc2b2b;
}
.history-badge--grey {
	background: #e8edf4;
	color: #5a6b85;
}
</style>
